module.exports = __webpack_public_path__ + "static/img/logo2.29e3ffae.png";